import DownloadReceipt from './DownloadReceipt';
export { DownloadReceipt };
export default DownloadReceipt;
